import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from '../../../../api';  // Ensure this path matches your API utility file

export const fetchTrackSheet = createAsyncThunk("trackSheet/fetchTrackSheet", async () => {
  const response = await api.post("/tracksheet");
  console.log(response)
  return response.data.data;
});

export const addTrackSheet = createAsyncThunk(
  "trackSheet/addTrackSheet",
  async (trackSheetData, { dispatch, rejectWithValue }) => {
    try {
      const response = await api.post("/add-user", trackSheetData);
      dispatch(fetchTrackSheet());
      return response.data.message;  // Success message from backend
    } catch (error) {
      return rejectWithValue(error.response?.data.message || "Failed to save user");
    }
  }
);

export const deleteTrackSheet = createAsyncThunk(
  "trackSheet/deleteTrackSheet",
  async (trackSheetId, { dispatch, rejectWithValue }) => {
    try {
      const response = await api.post(`/delete-employee/${trackSheetId}`);
      dispatch(fetchTrackSheet());
      return response.data.message;  // Success message from backend
    } catch (error) {
      return rejectWithValue(error.response?.data.message || "Failed to delete user");
    }
  }
);

// Define the initial state and slice
const trackSheetSlice = createSlice({
  name: "trackSheetData",
  initialState: {
    data: [],
    loading: false,
    isModalOpen: false,
    selectedUserId: null,
    addLoading: false,
    deleteLoading: false,
    error: null,
    successMessage: null,
  },
  reducers: {
    openTrackSheetModal: (state, action) => {
      state.isModalOpen = true;
      state.selectedUserId = action.payload || null;
    },
    closeTrackSheetModal: (state) => {
      state.isModalOpen = false;
      state.selectedUserId = null;
      state.error = null;
      state.successMessage = null;
    },
    clearError: (state) => {
      state.error = null;
      state.successMessage = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchTrackSheet.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchTrackSheet.fulfilled, (state, action) => {
        state.data = action.payload;
        state.loading = false;
      })
      .addCase(fetchTrackSheet.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(addTrackSheet.pending, (state) => {
        state.addLoading = true;
      })
      .addCase(addTrackSheet.fulfilled, (state, action) => {
        state.addLoading = false;
        state.successMessage = action.payload;
      })
      .addCase(addTrackSheet.rejected, (state, action) => {
        state.addLoading = false;
        state.error = action.payload;
      })
      .addCase(deleteTrackSheet.pending, (state) => {
        state.deleteLoading = true;
      })
      .addCase(deleteTrackSheet.fulfilled, (state, action) => {
        state.deleteLoading = false;
        state.successMessage = action.payload;
      })
      .addCase(deleteTrackSheet.rejected, (state, action) => {
        state.deleteLoading = false;
        state.error = action.payload;
      });
  },
});

export const { openTrackSheetModal, closeTrackSheetModal, clearError } = trackSheetSlice.actions;
export default trackSheetSlice.reducer;
export { trackSheetSlice };